import { RootState } from 'store';
import { useSelector } from 'react-redux';

import { CARS_STATE } from '../../constants';
import { EMPTY_ARRAY } from 'common/constants';

export const useT4EObuDevices = () => {
  const selectedCarEBoxLocation = useSelector((state: RootState) => state[CARS_STATE].t4EboxDevices);
  return selectedCarEBoxLocation.data || EMPTY_ARRAY;
};

export const useLoadingStatusT4EObuDevices = () => {
  const loadingStatus = useSelector((state: RootState) => state[CARS_STATE].t4EboxDevices.loadingStatus);
  return loadingStatus;
};
